import "../../../css/wallet/History/HistoryLoading.css";

function HistoryLoading2({ theme }) {
  return (
    <div className={`dfffggrt4`}>
      {Array.from({ length: 2 }).map((_, index) => {
        return (
          <div className={`djkkwk2ds shimmer ${theme}`}></div>
        );
      })}
    </div>
  );
}

export default HistoryLoading2;
